[
  {
    "id": "TB-E8P-L306-001",
    "module": "Taalbegrip",
    "difficulty": 306,
    "question": "Wat betekent 'hypothetisch'?",
    "options": [
      "Aangenomen (als... dan...)",
      "Zeker",
      "Hyperactief",
      "Belangrijk"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-HYPOTHETISCH",
    "explanation": "Hypothetisch betekent dat je ervan uitgaat dat iets zo is, om te kijken wat er dan gebeurt.",
    "distractorExplanations": {
      "1": "Feitelijk.",
      "2": "Niet waar.",
      "3": "Niet waar."
    }
  },
  {
    "id": "TB-E8P-L306-002",
    "module": "Taalbegrip",
    "difficulty": 306,
    "question": "Wat is 'plagiaat'?",
    "options": [
      "Werk van een ander stelen",
      "Een ziekte",
      "Een straf",
      "Een compliment"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "taalbegrippen",
    "familyId": "TB-PLAGIAAT",
    "explanation": "Plagiaat is doen alsof werk van een ander van jou is.",
    "distractorExplanations": {
      "1": "Plaag.",
      "2": "Niet waar.",
      "3": "Niet waar."
    }
  },
  {
    "id": "TB-E8P-L306-003",
    "module": "Taalbegrip",
    "difficulty": 306,
    "question": "Wat betekent 'consensus'?",
    "options": [
      "Overeenstemming",
      "Ruzie",
      "Onderzoek",
      "Gevolg"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-CONSENSUS",
    "explanation": "Consensus betekent dat iedereen het erover eens is.",
    "distractorExplanations": {
      "1": "Conflict.",
      "2": "Census.",
      "3": "Consequentie."
    }
  },
  {
    "id": "TB-E8P-L306-004",
    "module": "Taalbegrip",
    "difficulty": 306,
    "question": "Wat is een 'drogreden'?",
    "options": [
      "Foutief argument",
      "Goed argument",
      "Droge grap",
      "Reden om te stoppen"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kritisch_lezen",
    "subSkill": "argumentatie",
    "familyId": "TB-DROGREDEN",
    "explanation": "Een drogreden is een argument dat niet klopt, maar wel zo klinkt.",
    "distractorExplanations": {
      "1": "Geldig argument.",
      "2": "Niet waar.",
      "3": "Niet waar."
    }
  },
  {
    "id": "TB-E8P-L306-005",
    "module": "Taalbegrip",
    "difficulty": 306,
    "question": "Wat betekent 'pragmatisch'?",
    "options": [
      "Praktisch / nuttig",
      "Moeilijk",
      "Theoretisch",
      "Prachtig"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-PRAGMATISCH",
    "explanation": "Pragmatisch betekent dat je kijkt naar wat werkt in de praktijk.",
    "distractorExplanations": {
      "1": "Niet waar.",
      "2": "Tegenovergestelde.",
      "3": "Lijkt erop."
    }
  }
]